import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ClientNotificationFiltersModel } from '../../Models/Domains/Users/NotificationFilter/ClientNotificationFiltersModel';

declare var IS_RUNNING_IN_APP_POOL;

export class NotificationFilterClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(): Promise<Array<ClientNotificationFiltersModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/User/NotificationFilter/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<Array<ClientNotificationFiltersModel>, any>(url, data);
  }
  public post(request: ClientNotificationFiltersModel): Promise<Array<ClientNotificationFiltersModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/User/NotificationFilter/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { request: request }

    return AjaxWrapper.post<Array<ClientNotificationFiltersModel>, any>(url, data);
  }
  public put(request: ClientNotificationFiltersModel): Promise<Array<ClientNotificationFiltersModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/User/NotificationFilter/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { request: request }

    return AjaxWrapper.put<Array<ClientNotificationFiltersModel>, any>(url, data);
  }
  public delete(request: ClientNotificationFiltersModel): Promise<Array<ClientNotificationFiltersModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/User/NotificationFilter/Delete';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { request: request }

    return AjaxWrapper.delete<Array<ClientNotificationFiltersModel>, any>(url, data);
  }
}

